<template>
  <div id="DetailPageView">
    <div v-if="!dataFetched">
      <detailPageLoader></detailPageLoader>
    </div>
    <div class="container" v-else>
      <div class="section-1">
        <video v-if="contentDetails.trailerUrl && !isMobile" class="video" autoplay :src="contentDetails.trailerUrl"
          muted="muted" id="vid" :poster="getPoster(contentDetails)" loop>
        </video>
        <div class="image-detail-ratio">
          <!-- <img :src="getPoster() ? getPoster() : placeholder_lands" class="carousel-poster-img"
            :alt="contentDetails.title" /> -->
          <img v-lazy="getPoster(contentDetails)" class="carousel-poster-img"
            :alt="contentDetails.title" decoding="async"/>
        </div>
        <div class="btn pointer mute" @click="ChangeMute" v-if="contentDetails.trailerUrl">
          <VolumeIcon :status="ismuted ? 'mute' : 'unmute'" />
        </div>
        <div class="image-wrapper">
          <div class="info">
            <div>
              <div class="title">{{ $t(`${contentDetails.title}`) }}</div>
            </div>
            <div class="mob-abjust">
              <div class="mob-adjust-2">
                <div class="epg-info" v-if="contentDetails.objecttype == 'EPGPROGRAMME'">{{ formatProgramTimeRange(contentDetails) }}</div>
                <div class="general-info">
                  <div class="channel-no" v-if="contentDetails.channelno">CH NO : {{ contentDetails.channelno }}</div>
                  <div class="catchup-period" v-if="contentDetails.catchupperiod">{{ catchUPText }}</div>
                  <div class="pg-rating" v-if="contentDetails.pgrating">{{ contentDetails.pgrating }}</div>
                  <div class="year" v-if="contentDetails.productionyear">{{ contentDetails.productionyear }}</div>
                  <div class="duration"
                    v-if="calcTimeFormat(contentDetails.duration) && contentDetails.objecttype !== 'SERIES'">
                    {{ calcTimeFormat(contentDetails.duration) }}
                  </div>
                  <div v-if="contentDetails.seasoncount" class="pg-rating">{{ seasonCountShow(contentDetails) }}</div>
                </div>
                <div class="tags">
                  <div>{{ $t(contentDetails.category) }}</div>
                  <div>{{ contentDetails.genre }}</div>
                  <div v-if="contentDetails.subgenre" v-for="single of contentDetails.subgenre">{{ single }}</div>
                  <div v-if="contentDetails && contentDetails.contentlanguage && contentDetails.contentlanguage[0]">
                    {{ $t(contentDetails.contentlanguage[0]) }}</div>
                </div>
                <div class="description">
                  <Description :toggle="false" :descStyle="descStyle" :whereIAmFrom="'detailsPage'"
                    :content="contentDetails" />
                </div>
                <div class="renal-validity" v-if="expireTxt"> {{ $t('rental-validity') }} <span>{{ expireTxt }}</span>
                </div>
              </div>
              <div class="buttons">
                <StatusButton :parentData="contentDetails" :availabilitiesData="availabilities" v-if="!(contentDetails.category == 'TVCHANEL' && isItFutureProgram(contentDetails))"></StatusButton>
                <div class="secondary-btns" v-if="!(contentDetails.objecttype == 'EPGPROGRAMME')">
                <div class="btn pointer">
                  <CspaceLikeBtn :content="contentDetails" /> 
                  <span>{{$t('Like')}}</span>
                </div>
                <div class="btn pointer">
                  <DisLike :content="contentDetails" /> 
                  <span>{{$t("dislike")}}</span>
                </div>
                <div class="btn pointer">
                  <CspaceDetailShare :content="contentDetails" /> 
                  <span>{{$t('Share')}}</span>
                </div>
                <div class="btn pointer" v-if="contentDetails.contentprovider !== 'hotgo'">
                  <CspaceWatchlistBtn :content="contentDetails" /> 
                  <span>{{$t('Watchlist')}}</span>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-2">
        <!-- <keep-alive> -->
          <Tab :tabs="tabs" v-if="tabs.length > 0">
            <template v-slot="{ tab }">
              <div v-if="tab.name === 'Episodes'">
              <!-- <keep-alive> -->
                <episodeCard :contentDetails="contentDetails">
                </episodeCard>
              <!-- </keep-alive> -->
              </div>
              <div v-if="tab.name === 'Related'">
                <div class="tab-container">
                  <RelatedSection :contentDetails="contentDetails" :playerInstance="playerInstance"></RelatedSection>
                  <!-- <MoreLikeThis :contentDetails="contentDetails" :playerInstance="playerInstance"></MoreLikeThis> -->
                </div>
              </div>
              <div v-if="tab.name === 'Details'">
                <div class="cast-crew" v-if="contentDetails.castncrew">
                  <div class="cast">
                    <RoundSlider :title="'Cast'" :id="'first'" :castncrew="contentDetails.castncrew.cast"></RoundSlider>
                  </div>
                  <div class="crew">
                    <RoundSlider :title="'Crew'" :id="'two'" :castncrew="contentDetails.castncrew.crew"></RoundSlider>
                  </div>
                </div>
                <div v-else class="no-found">
                  <div class="EmptyContainer">
                    <EptyBin></EptyBin>
                    <p> {{ $t("No Details found") }} </p>
                  </div>
                </div>
              </div>
              <div v-if="tab.name === 'Trailer'">
                <TrailerCom :contentDetails="contentDetails" :playerInstance="playerInstance"></TrailerCom>
              </div>
              <div v-if="tab.name === 'Program Guide'" class="program-guide">
                <EpgContainer :headerContainer="false" :channelCard="false" :channelno="contentDetails.channelno" :idepgchannel="contentDetails.idepgchannel"></EpgContainer>
              </div>
            </template>
          </Tab>
          <TabsPlaceHolder v-else />
        <!-- </keep-alive> -->
      </div>
    </div>
    <!-- <PinModal id="pc-pin-detail-modal-player-config" :open="showPinModal" @onClose="closePinModal" :mode="pinMode"
      @onActionComplete="onPinModalActionComplete" :pinError="pinModalError"
      :callbackParentalLockFlag="callbackParentalLockFlag" :loading="pinModalLoading"
      @onForgotPin="openForgotPinModal" />
    <ForgotPinModal id="pc-forgot-pin-modal" :open="showForgotPinModal" @onClose="closeForgotPinModal"
      @onActionComplete="onForgotPinModalActionComplete" :pinError="forgotPinModalError" @onResend="resendOtp"
      :loading="loading" />
    <Popup v-if="isLiveContentAccessError" :islogoNotRequired="true" width="max-content" margin="15% auto"
      radiusType="full" :closePopupEvent="() => { closePopup() }">
      <div class="confirmation-box" slot="component">
        <div class="confirmation-body">
          <h5>{{ $t("liveContentAccessError")}}</h5>
          <div class="login-button">
            <button class="button-primary login" type="Button" @click.stop="closePopup()">
              {{ $t("OK") }}
            </button>
          </div>
        </div>
      </div>
    </Popup> -->
  </div>
</template>

<script>
import Utility from "@/mixins/Utility.js";
import Redirection from "@/mixins/redirection.js";
import { eventBus } from "@/eventBus";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { store } from "@/store/store";
import { showSnackBar } from "@/utilities";
import { getDatabase, ref, onValue, get } from "firebase/database";
import Tab from '../tab/Tab.vue';
import StatusButton from "./StatusButton.vue";

export default {
  props: {
    playerInstance: {
      type: Object,
    },
  },
  data() {
    return {
      tabs: [],
      ismuted: true,
      Mute: require('@/assets/icons/mute.png'),
      Unmute: require('@/assets/icons/unmute.png'),
      GetKidProfile: "",
      dataFetched: false,
      localDisplayLang: null,
      contentDetails: {},
      contentId: null,
      readMore: false,
      tabList: [],
      selectedSection: null,
      activeTab: "active-tab",
      activeComponent: "",
      showErrorMessage: false,
      seasonNum: 1,
      seasonCount: null,
      seasonCountArray: [],
      subscriptions: [],
      availabilities: [],
      purchases: [],
      filteredAvailabilities: [],
      pricemodel: [],
      buttonStatus: "",
      fetchStreamUrlTask: null,
      playbackInitiated: false,
      isMpegRequired: false,
      isDrmFree: true,
      progress: null,
      watchedTime: null,
      playerPositionPerecentage: null,
      currentEpisode: "",
      watchedEpisodeButton: "",
      showPinModal: false,
      pinModalError: "error message",
      pinMode: "restrict",
      callbackParentalLockFlag: "",
      isLoaderEnabled: false,
      shareLink: null,
      pinModalLoading: false,
      parentalControlsEnabled: false,
      disableLanguage: false,
      configCTTag: false,
      showForgotPinModal: false,
      forgotPinModalError: "",
      forgetpinloader: false,
      loading: false,
      rentNowPriceModel: {},
      isPopupClose: false,
      availPlanListPopup: {},
      rentPurchasedActive: false,
      expireTxt: '',
      userInfoDetails: [],
      timeleft: "",
      isARentalContent: false,
      isMobile: false,
      chanelBtnStatus: "",
      seriesBtnStatus: "",
      descStyle: {
        font: 1,
        width: 100
      },
      placeholder_lands: require('@/assets/placeholder-lands.svg'),
      noEpisodeData: false,
      episodesList: null,
      isLiveContentAccessError: false,
      purchaseListData: []
    };
  },
  watch: {
    $route(to, from) {
      this.scrollTop();
      this.dataFetched = false;
      this.selectedSection = null;
      this.tabs = [];
      this.contentDetails = null;
      this.contentId = to.params.contentId;
      this.buttonStatus = "";
      this.getContentDetail(this.contentId);
    },
    availabilityList(val) {
      if (Array.isArray(val) && val.length > 0) {
        this.availabilities = val;
      }
    },
    subscriptionList(newVal, oldVal) {
      if (Array.isArray(newVal) && newVal.length > 0) {
        this.subscriptions = newVal;
      }
      eventBus.$emit("check-new-fire-data");
      this.fetchTabList();
      // alert("new subscription added");
    },
    purchaseList(val) {
      this.purchaseListData = val;
      this.getPurchaseListCode();
    },
    getContentData(newVal, oldVal) {
      this.contentDetails = newVal;
      let contentId = this.$route.params.contentId;
      if(this.subscriberid && this.contentDetails.objecttype != "SERIES") {
        if(newVal.contentdetails) {
          this.callProgressAndAvailability(newVal);
        } else {
          this.contentDetailsApiCall(contentId);
        }
      }
    }   
  },
  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;
    localStorage.setItem("paymentGetwaySaveUrl", location.href)
    try {
      this.userInfoDetails = localStorage.getItem("subscriberDetails") ? JSON.parse(localStorage.getItem("subscriberDetails")).data : [];
    } catch (err) {
      // console.log(err)
    }
    let subscriberProfileDetails = localStorage.getItem("subscriberProfileDetails");
    let isenabled = localStorage.getItem("parentalControlEnabled") == 'true' ? true : false;
    this.parentalControlsEnabled = isenabled;
    if (subscriberProfileDetails) {
      subscriberProfileDetails = JSON.parse(subscriberProfileDetails);
    }
    this.contentId = this.$route.params.contentId;
    //assigning subscription list response.
    if (this.subscriptionList !== undefined) {
      this.subscriptions = this.subscriptionList;
    }
    if (this.purchaseList !== undefined) {
      this.purchaseListData = this.purchaseList;
      this.getPurchaseListCode()
    }
  
    eventBus.$on("re-login-success", async () => {
      // this.buttonStatus = "";
      // await this.getPlayBackAvailabilityStatus(this.contentDetails);
      // await this.getContentProgress(this.contentDetails);
    });
  },

  computed: {
    ...mapGetters([
      "appConfig",
      "subscriberid",
      "availabilityList",
      "subscriptionList",
      "purchaseList",
      "getAudioAndSubtitleLangState",
      "getAllLanguageFullForm",
      "profileid",
      "getSubscriptionInformation",
      "getContentData",
      "getContentPlayingFromRails"
    ]),

    checkScreenWidth: function () {
      if (screen.width > 900) {
        return true;
      } else {
        return false;
      }
    },

    contentTags() {
      return this.contentDetails.tags[0].toLowerCase();
    },

    seasons: function () {
      if (
        this.contentDetails &&
        this.contentDetails.seasoncount &&
        this.contentDetails.seasoncount > 1
      ) {
        return this.contentDetails.seasoncount + " " + "Seasons";
      } else if (
        this.contentDetails &&
        this.contentDetails.seasoncount &&
        this.contentDetails.seasoncount <= 1
      ) {
        return this.contentDetails.seasoncount + " " + "Season";
      } else {
        return "";
      }
    },
    actGetEpisodeList: function (data) {
      // console.log(data)
    },
    checkDescription: function () {
      if (
        (this.contentDetails && this.contentDetails.longdescription) ||
        (this.contentDetails && this.contentDetails.shortdescription)
      ) {
        return true;
      } else {
        return false;
      }
    },

    checkDescriptionLength: function () {
      if (
        (this.contentDetails &&
          this.contentDetails.longdescription &&
          this.contentDetails.longdescription.length > 250) ||
        (this.contentDetails &&
          this.contentDetails.shortdescription &&
          this.contentDetails.shortdescription.length > 250)
      ) {
        return true;
      } else {
        return false;
      }
    },

    checkMovie: function () {
      if (this.contentDetails.objecttype == 'SERIES') {
        return true;
      } else {
        return true;
      }
    },

    catchUPText() {
      const displayText = this.appConfig?.displayText;
      return (
        displayText?.[this.localDisplayLang]?.CatchUPText ||
        displayText?.default?.CatchUPText || 'CU TV'
      );
    },
  },
  mounted() {
    //To check for newly added firebase data.
    // eventBus.$on("check-new-fire-data", async () => {
    //   if (this.subscriberid && this.contentDetails.objecttype != "SERIES") {
    //     await this.getPlayBackAvailabilityStatus(this.contentDetails);
    //     await this.getContentProgress(this.contentDetails);
    //   }
    // });
    this.scrollTop();
    this.contentId = this.$route.params.contentId;
    this.getContentDetail(this.contentId);
    this.createLink("sharing");
    this.timeleft = this.$t("minutesLeft")
    document?.getElementById('vid')?.play();
    this.isMobile = window.innerWidth <= 600 ? true : false,
    this.GetKidProfile = localStorage.getItem("isKidsMode");
    // this.getEpisodeContentProgress();
    eventBus.$on("changeLanguageView", () => {
      location.reload();
    });
    this.disableLanguage = window.PROVIDER_SETUP_CONFIG.isActiveDetailLanguage;
  },
  components: {
    StatusButton,
    Tab,
    TrailerCom: () => import('@/components/DetailPage/trailerCard.vue'),
    Slider: () => import('@/themeearth/components/dashboard/sliderCarousel/Slider.vue'),
    RoundSlider: () => import("@/themeearth/components/dashboard/sliderCarousel/RoundSlider.vue"),
    RelatedSection: () => import("@/components/DetailPage/relatedCard.vue"),
    // MoreLikeThis: () => import("@/components/DetailPage/moreLikeThis.vue"),
    detailPageLoader: () => import(/* webpackChunkName: "detailPageLoader" */ "@/components/DetailPage/detailPageLoader.vue"),
    CspaceLikeBtn: () => import(/* webpackChunkName: "likebutton" */ "../../../components/SvgImages/CspaceLikeBtn.vue"),
    DisLike: () => import(/* webpackChunkName: "Dislikebutton" */ "../../../components/SvgImages/DisLike.vue"),
    CspaceDetailShare: () => import(/* webpackChunkName: "Detailbutton" */ "../../../components/SvgImages/CspaceShareBtn.vue"),
    CspaceWatchlistBtn: () => import(/* webpackChunkName: "watchbutton" */ "../../../components/SvgImages/CspaceWatchlistBtn.vue"),
    VolumeIcon: () => import(/* webpackChunkName: "volumeIcon" */ "@/components/SvgImages/Volume.vue"),
    Description: () => import(/* webpackChunkName: "description" */ "@/components/Text/Description.vue"),
    episodeCard: () => import(/* webpackChunkName: "description" */ "@/components/DetailPage/episodeCard.vue"),
    DotFlashing: () => import(/* webpackChunkName: "dotFlashing" */ "@/components/Loaders/DotFlashing.vue"),
    EptyBin: () => import(/* webpackChunkName: "eptyBin" */ "@/components/SvgImages/Empty.vue"),
    ForgotPinModal: () => import("@/components/utils/ForgotPinModal.vue"),
    PinModal: () => import(/* webpackChunkName: "PinModal" */  "@/components/utils/PinModal.vue"),
    TabsPlaceHolder: () => import(/* webpackChunkName: "tabsPlaceHolder" */ "@/components/placeholders/TabsPlaceHolder.vue"),
    Popup: () => import(/* webpackChunkName: "Popup" */ "@/components/Slots/Popup.vue"),
    EpgContainer: () => import(/* webpackChunkName: "epgContainer" */ "@/components/Epg/EpgContainer.vue")
  },
  methods: {
    ...mapMutations(["setRegActiveDeeplink", "setAudioAndSubtitleLangState", "setActivePlaylist"]),
    ...mapActions([
      "getLanguagesByCodes",
      "parentalControlVerifyOldPin",
      "authorizeCurrentStreamApi",
      "setCurrentStreamApi",
      "parentalControlPinSet",
      "parentalControlResetPin",
      "availabilityDetail",
      "subscriberPlaybackExpiry"
    ]),

    async callProgressAndAvailability(val) {
      await this.getPlayBackAvailabilityStatus(val);
      await this.getContentProgress(val);
    },

    videoPlayListPlayerUnloaded() {
      // alert("Unloaded video");
    },

    ChangeMute() {
      this.ismuted = !this.ismuted;
      const video = document.getElementById('vid');
      video.muted = !video.muted;
    },

    getFormatedDate(list) {
      let d = "";
      d = list.expiry
      if (list.expiryafterfirstplay) {
        d = list.expiryafterfirstplay
      }
      function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
      }

      try {
        let newDate = new Date(d);

        newDate.setHours(newDate.getHours() + 5);
        newDate.setMinutes(newDate.getMinutes() + 30);

        return newDate.getDate() + " " + newDate.toLocaleString('default', {
          month: 'short'
        }) + " " + newDate.getFullYear() + ", " + formatAMPM(newDate);
      } catch (e) {
        return d;
      }
    },

    getPurchaseListCode() {
      for (let list of this.purchaseListData) {

        if ((list.objectid).toLowerCase() == (this.contentId || this.$route.params.contentId).toLowerCase()) {
          this.rentPurchasedActive = true;
          this.expireTxt = this.getFormatedDate(list);

        }
      }
    },

    calcTimeFormat(val) {
      if (!val) return;
      let totalTime = val;
      let hours = Math.floor(totalTime / 3600);
      let minutes = Math.floor((totalTime - hours * 3600) / 60);

      let showTime =
        (hours ? hours.toString().padStart(2, "0") + this.$t("hr") : "") +
        " " +
        (minutes ? minutes.toString().padStart(2, "0") + (minutes === 1 ? this.$t("min") : this.$t("mins")) : "");

      if (showTime == " ") {
        return val + this.$t("secs");
      } else {
        return showTime;
      }
    },

    // resendOtp() {
    //   //do something here. (Make call to the API)
    //   this.loading = true;
    //   let payload = {
    //     otp_type: "parentalControlPinUpdate",
    //   };
    //   //do something here. (Make call to the API)
    //   //received otp to email
    //   this.parentalControlPinSet(payload)
    //     .then((data) => {
    //       this.loading = false;
    //       if (data.data.reason) {
    //         this.pinModalError = this.$t(data.data.reason);
    //         return;
    //       }
    //     })
    //     .catch((error) => {
    //       // console.log("parentalControlPinSet error -> ", error);
    //     });
    // },

    // closeForgotPinModal() {
    //   this.showForgotPinModal = false;
    // },

    // onForgotPinModalActionComplete(data) {
    //   // forget pin reset api call
    //   this.loading = true;
    //   let forgetPinPayload = {
    //     pin: data.pin,
    //     OTP: data.otp,
    //   };
    //   this.parentalControlResetPin(forgetPinPayload)
    //     .then((data) => {
    //       this.loading = false;
    //       if (data.data.reason) {
    //         this.forgotPinModalError = this.$t(data.data.reason);
    //         return;
    //       } else if (data.data.success) {
    //         this.showForgotPinModal = false;
    //       }
    //     })
    //     .catch((error) => {
    //       // console.log("parentalControlResetPin error -> ", error);
    //     });
    // },

    // openForgotPinModal() {
    //   const isKidsMode = localStorage.getItem("isKidsMode") === "true";
    //   if (isKidsMode) {
    //     this.pinModalError = this.$t("Unauthorized access");
    //     // return;
    //   }
    //   this.showForgotPinModal = true;
    //   this.loading = true;


    //   let payload = {
    //     otp_type: "parentalControlPinUpdate",
    //   };

    //   this.parentalControlPinSet(payload)
    //     .then((data) => {
    //       this.loading = false;
    //       if (data.data.reason) {
    //         this.pinModalError = this.$t(data.data.reason);
    //       }
    //     })
    //     .catch((error) => {
    //       // console.log("parentalControlPinSet error -> ", error);
    //     });
    // },

    async contentRenderSetup(content) {
      this.dataFetched = true;
      this.contentDetails = content;
      await this.fetchTabList();
      this.contentDetails.trailerUrl = this.contentDetails.trailer && this.contentDetails.trailer[0] && this.contentDetails.trailer[0].filelist[0].filename;
      let subscriberProfileDetails = localStorage.getItem("subscriberProfileDetails");
      if (subscriberProfileDetails) {
        subscriberProfileDetails = JSON.parse(subscriberProfileDetails);
      }
      if (this.availabilities?.length == 0) {
        this.availabilities = this.availabilityList;
      }
      window.document.title = 'Watch' + ' ' + (this.contentDetails.defaulttitle || this.contentDetails.title) + ' on mvshub';
      this.seasonNum = this.contentDetails.seasoncount;
      // if (
      //   subscriberProfileDetails &&
      //   subscriberProfileDetails.kidsmode === "YES" &&
      //   this.contentDetails.defaultgenre !== "KIDS"
      // ) {
      //   showSnackBar(this.$t("Content is not accessible"));
      //   this.$router.replace("/");
      // }
    },

    scrollTop() {
      window.scrollTo(0, 0);
    },

    // goBack() {
    //   this.$router.push({ path: "/" });
    // },

    getContentDetail(contentid) {
      if (this.getContentData && this.getContentData.objectid == this.$route?.params?.contentId) {
        if(!this.getContentData.contentdetails && !(this.getContentData.objecttype == 'SERIES' || this.getContentData.objecttype == 'SHOWS')) {
          console.log("calling API");
          this.contentDetailsApiCall(contentid);
        } else {
          console.log("Not calling API");
          this.dataFetched = true;
          this.contentRenderSetup(this.getContentData);
        }
      } else {
        console.log("Not calling API objectid not matched");
        this.contentDetailsApiCall(contentid)
      }
    },

    contentDetailsApiCall(contentid) {
       let payload = {
          contentid: contentid,
          params: {
            displaylanguage: this.localDisplayLang,
          },
        };
        store
          .dispatch("contentDetail", payload)
          .then((response) => {
            if (response?.data && !response.data.reason) {
              this.contentRenderSetup(response.data);
            } else {
              eventBus.$emit(`contentDetail-error-response-${payload.contentid}`, response);
              this.dataFetched = true;
              this.showErrorMessage = true;
            }
          })
          .catch((error) => {
            // console.log(error)
            this.showErrorMessage = true;
          });
    },

    getPoster(content) {
      if (content.posterurl) {
        return content.posterurl
      }
      if (Array.isArray(content.poster)) {
        // Find LANDSCAPE poster with CAROUSEL usage first
        let poster = content.poster.find((element) => {
          return element.postertype === "LANDSCAPE" && element.posterusage === "CAROUSEL";
        });
        // If no CAROUSEL found, look for LANDSCAPE with RAIL
        if (!poster) {
          poster = content.poster.find((element) => {
            return element.postertype === "LANDSCAPE" && element.posterusage === "RAIL";
          });
        }
        // If a valid poster is found, select quality in order: HD, SD, LOW, THUMBNAIL
        if (poster && Array.isArray(poster.filelist) && poster.filelist.length > 0) {
          const qualityOrder = ["HD", "SD", "LOW", "THUMBNAIL"];
          for (let quality of qualityOrder) {
            const file = poster.filelist.find((f) => f.quality === quality);
            if (file) {
              return file.filename;
            }
          }
        }
      }
      // Fallback to thumbnail if provided
      if (content.thumbnail) {
        return content.thumbnail;
      }
      return null; // Return null if no valid poster is found
    },
    fetchTabList() {
      if (this.contentDetails.objecttype == "CHANEL" || this.contentDetails.objecttype == "EPGPROGRAMME") {
        this.tabs = [{name: 'Program Guide'}];
        // this.tabs = [{ name: 'Related' }];
      } else if (
        this.contentDetails.objecttype == 'CONTENT' &&
        this.contentDetails.trailer &&
        this.contentDetails.trailer.length > 0
      ) {
        this.tabs = [{ name: 'Related' }, { name: 'Details' }, { name: 'Trailer' }];
      } else if (this.contentDetails.objecttype == 'CONTENT') {
        this.tabs = [{ name: 'Related' }, { name: 'Details' }];
      } else if (
        this.contentDetails.objecttype == 'SERIES' &&
        this.contentDetails.trailer &&
        this.contentDetails.trailer.length > 0
      ) {
        this.tabs = [{ name: 'Episodes' }, { name: "Related" }, { name: 'Details' }, { name: 'Trailer' }];
        if (
          this.contentDetails.tags &&
          this.contentDetails.tags[0].toLowerCase() === "upcoming"
        ) {
          this.tabs.splice(0, 1);
        }
      } else if (
        this.contentDetails.objecttype == 'SERIES' &&
        !this.contentDetails.trailer &&
        this.contentDetails.tags && this.contentDetails.tags.length &&
        this.contentDetails.tags[0].toLowerCase() === "upcoming"
      ) {
        this.tabs = [{ name: 'Related' }, { name: 'Details' }];
      } else if (
        this.contentDetails.objecttype == 'SERIES' &&
        !this.contentDetails.trailer
      ) {
        this.tabs = [{ name: 'Episodes' }, { name: "Related" }, { name: 'Details' }];
      } else if (this.contentDetails.objecttype == 'SERIES') {
        this.tabs = [{ name: 'Episodes' }, { name: "Related" }, { name: 'Details' }, { name: 'Trailer' }];
      } else if (this.contentDetails.objecttype == 'SEASON') {
        this.tabs = [{ name: "Related" }, { name: 'Details' }];
      }
    },

    createLink(medium) {
      this.shareLink = window.location.href;
    },

    copyLink() {
      navigator.clipboard.writeText(this.shareLink);
      showSnackBar("Link copied to clipboard");
    },

    closePopup() {
      this.isLiveContentAccessError = false;
    },

    seasonCountShow(data) {
      if(data.seasoncount > 1) {
        return `${data.seasoncount} Seasons`
      }else {
        return `${data.seasoncount} Season`
      }
    },
  },
  beforeDestroy() {
    eventBus.$off("changeLanguageView");
  },
  mixins: [Utility, Redirection],
};
</script>


<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
$breakpoint-small: 576px;
$breakpoint-medium: 768px;
$breakpoint-large: 992px;
$breakpoint-extra-large: 1200px;

.no-found {
  width: inherit;
  text-align: center;
  margin: 2rem 0 2rem 0;
  color: var(--clr-close-light-dark);
}

.mute {
  align-self: end;
  margin-right: 2rem;
  position: absolute;
  right: 3%;
  bottom: 22%;
  z-index: 99;
}

.button-primary {
  width: 100%;
  padding: 0.7rem;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.03rem;
  line-height: 0.7rem;
  text-align: center;
  border-radius: 0.3rem;
  color: #000;
  background: $primary-btn-color;
  ;
  border-color: transparent !important;
  transition: 0.3s linear all;
  border: 2px solid #ffffff;
  cursor: pointer;
}

.login-watch {
  background: $primary-btn-color;
  color: #FFFFFF;
  padding: 0.8rem;
  border-radius: 0.3rem;
  font-size: 0.8rem;
  font-weight: bold;
  text-align: center;
  border-color: transparent !important;
  cursor: pointer;
}

.container {
  // font-size: 16px;
  width: 100%;

  .section-1 {
    position: relative;

    .video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .carousel-poster-img {
      min-width: 100%;
      min-height: 100%;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-wrapper {
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0.7) 23%, transparent 50%), linear-gradient(to top, black 8%, rgba(0, 0, 0, 1) 25%, rgba(0, 0, 0, 0.3) 34%);

      .info {
        display: flex;
        flex-direction: column;
        width: clamp(2rem, 100%, 95%);
        row-gap: 0.5rem;
        margin: 0 auto;

        .title {
          font-size: 2rem;
          color: #fff;
          text-transform: uppercase;
          width: 45%;
        }

        .mob-abjust {
          display: flex;
          flex-direction: column;
          row-gap: 1rem;
          width: 45%;

          .mob-adjust-2 {
            display: flex;
            flex-direction: column;
            row-gap: 0.7rem;

            .description {
              font-size: 1rem;
              font-weight: 300;
            }

            .general-info {
              display: flex;
              gap: 0.75rem;
              .channel-no {
                border: 0.1rem solid gray;
                border-radius: 0.2rem;
                padding: 0.2rem 0.6rem;
              }
              .catchup-period {
                background: red;
                border-radius: 0.2rem;
                padding: 0.2rem 0.4rem;
                align-content: end;

              }
              .pg-rating {
                background-color: gray;
                border-radius: 0.2rem;
                padding: 0.2rem 0.6rem;
              }
            }

            .tags {
              display: flex;
              gap: 0.5rem;
            }

            // .tags div:not(:first-child)::before {
            //   content: '\2022';
            //   /* Unicode for bullet point */
            //   margin-right: 0.6rem;
            //   /* Adjust as needed for spacing */
            // }
          }

          .buttons {
            display: flex;
            // flex-direction: column;
            column-gap: 1rem;
            align-items: center;
            margin-bottom: 1.5rem;

            .main-btn {
              background-color: #ffffff;
              padding: 0.6rem 2.1rem;
              color: black;
              border-radius: 0.6rem;
              height: fit-content;
              text-align: center;
            }

            .secondary-btns {
              display: flex;
              column-gap: 1rem;
              align-items: center;
              justify-content: flex-end;
            .btn.pointer {
              span {
              display: flex;
              flex-direction: column;
              align-items: center;
              font-size: 12px;
              }
            }
            }
          }
        }
      }

    }
  }

  .section-2 {
    position: relative;
    z-index: 1;
    min-height: 10rem;
    width: clamp(2rem, 100%, 95%);

    .cast-crew {
      display: grid;

      .cast {
        width: 100%;

      }

      .crew {
        margin-top: 2%;
        width: 100%;

      }

      // display: grid;
    }
  }
}
@media only screen and (max-width: 767px) {
  .container {
    font-size: 12px;

    .section-1 {
      margin-top: 4rem;
      display: flex;
      flex-direction: column;
      .pointer {
        cursor: pointer;
      }

      .mute {
        display: none
      }

      .image-wrapper {
        width: 100%;
        padding: 0;
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0.7) 23%, transparent 50%), linear-gradient(to top, black 0%, black 2.5%, rgba(0, 0, 0, 0.3) 34%);
        .info {
          width: 100%;
          padding: 0.5rem;
          gap: 0.5rem;
          .title {
            font-size: 1rem;
            text-transform: uppercase;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            text-wrap: nowrap;
          }

          .mob-abjust {
            display: flex;
            row-gap: 0.5rem !important;
            justify-content: space-around;
            width: 99%;

            .mob-adjust-2 {
              display: flex;
              row-gap: 0.5rem !important;

              .general-info {
                .pg-rating {
                  background: none;
                  border: 0.1rem solid gray;
                  border-radius: 0.2rem;
                  padding: 0.2rem 0.4rem 0.2rem 0.4rem;
                }
              }
              .tags{
                div {
                  padding: 0.2rem;
                  background: gray;
                  border-radius: 0.1rem;
                  font-size: clamp(0.5rem, 1.5vh, 1rem);
                }
              }
              .description {
                color: #777;
                font-size: clamp(0.5rem, 1.5vh, 1rem);
              }
            }

            .buttons {
              align-items: center;
              row-gap: 0.5rem;
              margin-bottom: 0 !important;

              .secondary-btns {
                justify-content: space-evenly;
              }
            }
          }
        }
      }
    }
    .section-2 {
      width: clamp(2rem, 100%, 100%) !important;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .container {
    font-size: 12px;

    .section-1 {
      position: relative;
      // margin-top: 4rem;

      .pointer {
        cursor: pointer;
      }

      .mute {
        display: none
      }

      .image-wrapper {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // padding-left: 5rem;
        top: 0%;
        left: 0%;
        height: 100%;
        width: 100%;
        padding: 0;
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0.7) 23%, transparent 50%), linear-gradient(to top, black 0%, black 2.5%, rgba(0, 0, 0, 0.3) 34%);

        .description {
          display: block;
          font-size: 0.8rem !important;
          width: 75%;
        }

        .info {
          width: 100%;
          // transform: translate(0px, 400px);
          padding: 0px 1.5rem;

          .title {
            font-size: 1rem;
            text-transform: uppercase;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            text-wrap: nowrap;
          }

          .mob-abjust {
            display: flex;
            row-gap: 0.3rem !important;
            justify-content: space-around;
            width: 99%;

            .mob-adjust-2 {
              display: flex;
              row-gap: 0.3rem !important;
              .tags div:not(:first-child)::before {
                content: '\2022';
                /* Unicode for bullet point */
                margin-right: 0.6rem;
                /* Adjust as needed for spacing */
              }
            }

            .buttons {
              align-items: center;
              row-gap: 0.5rem;
              margin-bottom: 0 !important;

              .secondary-btns {
                justify-content: space-evenly;
              }
            }
          }
        }
      }
    }

    .section-2 {
      // background: rgba(0, 0, 0, 0.9);
      margin: -6rem auto 0;
      .cast-crew {
        .cast {
          width: 100%;
        }

        .crew {
          width: 100%;
        }
      }
      .tags div:not(:first-child)::before {
        content: '\2022';
        /* Unicode for bullet point */
        margin-right: 0.6rem;
        /* Adjust as needed for spacing */
      }
    }
  }
}

.image-detail-ratio {
  aspect-ratio: 2 / 1;
}

@media only screen and (min-width: 1024px)and (max-width: 1441px) {
  .image-detail-ratio {
    aspect-ratio: 16 / 9 !important;
  }

  .image-wrapper {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding-left: 5rem;
      top: 0%;
      left: 0%;
      height: 100%;
      width: 100%;
      .info {
        .mob-abjust {
          .mob-adjust-2 {

            .tags div:not(:first-child)::before {
              content: '\2022';
              /* Unicode for bullet point */
              margin-right: 0.6rem;
              /* Adjust as needed for spacing */
            }
          }
        }
      }
  }
  .section-2 {
    margin: -11rem auto 0;
  }
}
@media only screen and (min-width: 1441px) {
  .image-wrapper {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding-left: 5rem;
      top: 0%;
      left: 0%;
      height: 100%;
      width: 100%;
      .info {
        .mob-abjust {
          .mob-adjust-2 {

            .tags div:not(:first-child)::before {
              content: '\2022';
              /* Unicode for bullet point */
              margin-right: 0.6rem;
              /* Adjust as needed for spacing */
            }
          }
        }
      }
  }
  .section-2 {
    margin: auto;
    margin-top: -17rem;
  }
}
.confirmation-box {
  .confirmation-body {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    text-align: center;
    .login-button {
      width: 50%;
    }
  }
}
.program-guide {
  padding: 1rem;
}
</style>

